export default "__VITE_ASSET__CMWUVU0V__"